import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { OptimizationProcessStatus } from '../../../types/optimizationProcesses'
import { useDownloadResultsOptimizationProcess } from './useDownloadresultsOptimizationProcess'

export const DownloadResultsButton = ({
  optimizationProcessId,
  status,
}: {
  optimizationProcessId: number
  status: OptimizationProcessStatus
}) => {
  const { mutate: download, isLoading } =
    useDownloadResultsOptimizationProcess()
  const { t } = useTranslation()

  return (
    <Button
      icon={<FontAwesomeIcon icon={faDownload} />}
      onClick={(e) => {
        e.stopPropagation()
        download(optimizationProcessId)
      }}
      title={t('Download results')}
      label=""
      loading={isLoading}
      disabled={isLoading || status !== 'OP_DONE'}
      buttonType="button"
      type="blank-action"
      size="md"
    />
  )
}
